import _slicedToArray from "C:\\Users\\Himanshu\\OneDrive\\Desktop\\Portfolio Website\\portfolio-website\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/slicedToArray";
import _objectWithoutProperties from "C:\\Users\\Himanshu\\OneDrive\\Desktop\\Portfolio Website\\portfolio-website\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/objectWithoutProperties";
import _extends from '@babel/runtime/helpers/esm/extends';
import * as THREE from 'three';
import * as React from 'react';
import { useThree, createPortal, useFrame } from '@react-three/fiber';
import { useFBO } from './useFBO.js';
var RenderTexture = /*#__PURE__*/React.forwardRef(function (_ref, forwardRef) {
  var children = _ref.children,
    compute = _ref.compute,
    width = _ref.width,
    height = _ref.height,
    _ref$samples = _ref.samples,
    samples = _ref$samples === void 0 ? 8 : _ref$samples,
    _ref$renderPriority = _ref.renderPriority,
    renderPriority = _ref$renderPriority === void 0 ? 0 : _ref$renderPriority,
    _ref$eventPriority = _ref.eventPriority,
    eventPriority = _ref$eventPriority === void 0 ? 0 : _ref$eventPriority,
    _ref$frames = _ref.frames,
    frames = _ref$frames === void 0 ? Infinity : _ref$frames,
    _ref$stencilBuffer = _ref.stencilBuffer,
    stencilBuffer = _ref$stencilBuffer === void 0 ? false : _ref$stencilBuffer,
    _ref$depthBuffer = _ref.depthBuffer,
    depthBuffer = _ref$depthBuffer === void 0 ? true : _ref$depthBuffer,
    _ref$generateMipmaps = _ref.generateMipmaps,
    generateMipmaps = _ref$generateMipmaps === void 0 ? false : _ref$generateMipmaps,
    props = _objectWithoutProperties(_ref, ["children", "compute", "width", "height", "samples", "renderPriority", "eventPriority", "frames", "stencilBuffer", "depthBuffer", "generateMipmaps"]);
  var _useThree = useThree(),
    size = _useThree.size,
    viewport = _useThree.viewport;
  var fbo = useFBO((width || size.width) * viewport.dpr, (height || size.height) * viewport.dpr, {
    samples: samples,
    stencilBuffer: stencilBuffer,
    depthBuffer: depthBuffer,
    generateMipmaps: generateMipmaps
  });
  var _React$useState = React.useState(function () {
      return new THREE.Scene();
    }),
    _React$useState2 = _slicedToArray(_React$useState, 1),
    vScene = _React$useState2[0];
  var uvCompute = React.useCallback(function (event, state, previous) {
    var _fbo$texture, _previous$previousRoo;

    // Since this is only a texture it does not have an easy way to obtain the parent, which we
    // need to transform event coordinates to local coordinates. We use r3f internals to find the
    // next Object3D.
    var parent = (_fbo$texture = fbo.texture) == null ? void 0 : _fbo$texture.__r3f.parent;
    while (parent && !(parent instanceof THREE.Object3D)) {
      parent = parent.__r3f.parent;
    }
    if (!parent) return false; // First we call the previous state-onion-layers compute, this is what makes it possible to nest portals

    if (!previous.raycaster.camera) previous.events.compute(event, previous, (_previous$previousRoo = previous.previousRoot) == null ? void 0 : _previous$previousRoo.getState()); // We run a quick check against the parent, if it isn't hit there's no need to raycast at all
    var _previous$raycaster$i = previous.raycaster.intersectObject(parent),
      _previous$raycaster$i2 = _slicedToArray(_previous$raycaster$i, 1),
      intersection = _previous$raycaster$i2[0];
    if (!intersection) return false; // We take that hits uv coords, set up this layers raycaster, et voilà, we have raycasting on arbitrary surfaces

    var uv = intersection.uv;
    if (!uv) return false;
    state.raycaster.setFromCamera(state.pointer.set(uv.x * 2 - 1, uv.y * 2 - 1), state.camera);
  }, []);
  React.useImperativeHandle(forwardRef, function () {
    return fbo.texture;
  }, [fbo]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, createPortal( /*#__PURE__*/React.createElement(Container, {
    renderPriority: renderPriority,
    frames: frames,
    fbo: fbo
  }, children), vScene, {
    events: {
      compute: compute || uvCompute,
      priority: eventPriority
    }
  }), /*#__PURE__*/React.createElement("primitive", _extends({
    object: fbo.texture
  }, props)));
}); // The container component has to be separate, it can not be inlined because "useFrame(state" when run inside createPortal will return
// the portals own state which includes user-land overrides (custom cameras etc), but if it is executed in <RenderTexture>'s render function
// it would return the default state.

function Container(_ref2) {
  var frames = _ref2.frames,
    renderPriority = _ref2.renderPriority,
    children = _ref2.children,
    fbo = _ref2.fbo;
  var count = 0;
  useFrame(function (state) {
    if (frames === Infinity || count < frames) {
      state.gl.setRenderTarget(fbo);
      state.gl.render(state.scene, state.camera);
      state.gl.setRenderTarget(null);
      count++;
    }
  }, renderPriority);
  return /*#__PURE__*/React.createElement(React.Fragment, null, children);
}
export { RenderTexture };